import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/right-arrow.svg'
import _imports_1 from '../assets/expand.svg'


const _withScopeId = n => (_pushScopeId("data-v-74343b34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "messages-div" }
const _hoisted_2 = { class: "messages-heading" }
const _hoisted_3 = { class: "message-filter-div" }
const _hoisted_4 = { class: "message-display-div" }
const _hoisted_5 = { class: "message-button-div" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "messages-grid" }
const _hoisted_9 = ["onMouseup"]
const _hoisted_10 = { class: "message-button-div" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchableDropDown = _resolveComponent("SearchableDropDown")!
  const _component_ActiveMessagesPopup = _resolveComponent("ActiveMessagesPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" Active Messages "),
        _createVNode(_component_SearchableDropDown, {
          style: {"font-size":"18px"},
          placeholder: "Filter by package",
          options: _ctx.packages.concat(_ctx.externalPackages),
          name: "Package Filter",
          maxItem: "5",
          onSelected: _ctx.filterPackages
        }, null, 8, ["options", "onSelected"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          title: "Topics filter",
          class: _normalizeClass(["message-filter-button", { 'topic-bg': _ctx.messageFilter !== 'topic' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
          {
            _ctx.filterMessages('topic');
          }
        })
        }, null, 2),
        _createElementVNode("button", {
          title: "Services filter",
          class: _normalizeClass(["message-filter-button", { 'service-bg': _ctx.messageFilter !== 'service' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => {
          {
            _ctx.filterMessages('service');
          }
        })
        }, null, 2),
        _createElementVNode("button", {
          title: "Nodes filter",
          class: _normalizeClass(["message-filter-button", { 'node-bg': _ctx.messageFilter !== 'node' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => {
          {
            _ctx.filterMessages('node');
          }
        })
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "icon-button left-button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => {
            {
              _ctx.switchMessagePage(-1);
            }
          })
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRenderMessages(), (message) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["message-box", {
            'message-hover': _ctx.isHovering,
            'topic-bg': message.type === 'topic',
            'service-bg': message.type === 'service',
            'node-bg': message.type === 'node'
          }]),
              key: message.name,
              onMouseup: 
            () => {
              if (message.message) _ctx.onMouseUp(message.message);
            }
          
            }, _toDisplayString(message.name), 43, _hoisted_9))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => {
            {
              _ctx.switchMessagePage(1);
            }
          })
          }, _hoisted_12),
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => {
            {
              _ctx.popupVisible = true;
            }
          })
          }, _hoisted_14)
        ])
      ])
    ]),
    _createVNode(_component_ActiveMessagesPopup, {
      visible: _ctx.popupVisible,
      setVisible: (visible) => (_ctx.popupVisible = visible),
      packages: _ctx.packageToFilter ? [_ctx.packageToFilter] : _ctx.externalPackages
    }, null, 8, ["visible", "setVisible", "packages"])
  ], 64))
}